// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlayContainerCss_ogpzw30{outline:none;z-index:2;position:relative;}
.fixSizeCss_f1aw14ya{height:100%;width:100%;max-width:inherit;max-height:inherit;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/overlay/Overlay.css"],"names":[],"mappings":"AAAA,6BAA6B,YAAY,CAAC,SAAS,CAAC,iBAAiB,CAAC;AACtE,qBAAqB,WAAW,CAAC,UAAU,CAAC,iBAAiB,CAAC,kBAAkB,CAAC","sourcesContent":[".overlayContainerCss_ogpzw30{outline:none;z-index:2;position:relative;}\n.fixSizeCss_f1aw14ya{height:100%;width:100%;max-width:inherit;max-height:inherit;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
